import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path
            d="M6 1.75V10.25M1.75 6H10.25"
            stroke={props.color ?? ds.colorValue.icon.primary}
            strokeWidth={1.5}
            strokeLinecap="round"
        />
    </Svg>
);

export default SvgComponent;
